<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Assessment Scheme` : "Add Assessment Scheme" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12"
            ><v-text-field
              v-model.trim="form.name"
              label="Name"
              outlined
              dense
              disabled
              hide-details="auto"
              hint="Based on Internal and External Marks, Name will be auto generated."
              persistent-hint
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="12"
            ><v-textarea
              v-model.trim="form.description"
              label="Description*"
              outlined
              rows="2"
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="4"
            ><v-text-field
              v-model.trim="form.max_internal_marks"
              label="Maximum Internal Mark"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.number]"
          /></v-col>
          <v-col cols="4">
            <v-text-field
              v-model.trim="form.max_external_marks"
              label="Maximum External Mark*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required, rules.number]"
          /></v-col>
          <v-col cols="3"
            ><v-checkbox
              v-if="shouldShowScaleCheckbox"
              v-model="form.scale_to_hundred"
              label="Scale to 100"
              class="mt-0"
              hide-details="auto"
            ></v-checkbox
          ></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    assessment_scheme: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {
        use_internal: null,
        max_internal_marks: 0,
        max_external_marks: 0,
        name: "I0-E0-NS",
      },
    };
  },
  computed: {
    shouldShowScaleCheckbox() {
      const internal = Number(this.form.max_internal_marks || 0);
      const external = Number(this.form.max_external_marks || 0);
      return internal + external !== 100;
    },
  },
  watch: {
    "form.use_internal"(val) {
      if (val === "All" && this.form.no_of_internals > 0) {
        this.$nextTick(() => {
          this.form.use_internal = this.form.no_of_internals;
        });
      }
    },
    "form.max_internal_marks": "autoBuildName",
    "form.max_external_marks": "autoBuildName",
    "form.scale_to_hundred": "autoBuildName",
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.assessment_scheme };
      }
    },

    save() {
      if (this.$refs.form.validate()) {
        if (!this.form.max_internal_marks) this.form.max_internal_marks = "0";
        this.$emit(this.edit ? "update" : "create", this.form);
      }
    },
    showFields() {
      return (
        Number(this.form.max_internal_marks) !== 0 &&
        Number(this.form.max_external_marks) !== 0 &&
        this.form.max_internal_marks &&
        this.form.max_external_marks
      );
    },
    changeUseInternal() {
      this.$nextTick(() => {
        this.form.use_internal = 0;
      });
    },
    autoBuildName() {
      const internal = this.form.max_internal_marks;
      const external = this.form.max_external_marks;

      if (!external) return; // only require external

      const scale = this.form.scale_to_hundred ? "SC" : "NS";

      if (internal) {
        this.form.name = `I${internal}-E${external}-${scale}`;
      } else {
        this.form.name = `I0-E${external}-${scale}`;
      }
    },
  },
};
</script>

<style scoped></style>
